import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const RouteIcon = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14 14">
      <path d="M7.53846 14C7.46654 14 7.39534 13.9856 7.32907 13.9577C7.2628 13.9298 7.2028 13.8888 7.15261 13.8373C7.10242 13.7858 7.06306 13.7248 7.03684 13.6578C7.01063 13.5908 6.99809 13.5193 6.99998 13.4474V7.27351C6.99998 7.20211 6.97162 7.13363 6.92112 7.08313C6.87063 7.03264 6.80215 7.00428 6.73074 7.00428H0.552063C0.438807 7.00562 0.327909 6.97189 0.234577 6.90772C0.141244 6.84355 0.0700477 6.75208 0.0307501 6.64586C-0.0140024 6.51918 -0.0097799 6.38034 0.0425884 6.25662C0.0949567 6.13289 0.191688 6.03321 0.313787 5.97715L13.2372 0.0489398C13.3371 0.00319237 13.4485 -0.0109313 13.5566 0.00846291C13.6647 0.0278572 13.7643 0.079842 13.842 0.157445C13.9197 0.235048 13.9719 0.334559 13.9914 0.44263C14.0109 0.550702 13.997 0.662167 13.9514 0.762075L8.02814 13.6853C7.98525 13.7792 7.91629 13.8587 7.82948 13.9145C7.74267 13.9703 7.64165 14 7.53846 14Z" />
    </SvgIcon>
  );
};

export default RouteIcon;
